var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrivalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 196.5 234.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#e2e2e2;}.cls-4{fill:#b4b4b5;}.cls-5{fill:#303132;}.cls-6{fill:#209747;}.cls-7{fill:#21a54a;}.cls-8{fill:#181a1c;}.cls-9{fill:#6dc07e;}.cls-10{fill:#59595c;}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-2);}.cls-13{opacity:.32;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 98.25,
    y1: 0,
    x2: 98.25,
    y2: 234.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181a1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.4,
    y1: 59.29,
    x2: 98.66,
    y2: 116.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 37.44,
    y1: 165.63,
    x2: 137.03,
    y2: 108.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#181a1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#303132"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "98.15 0 0 58.6 0 175.79 98.21 234.35 196.5 175.79 196.5 58.6 98.15 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0 175.79 98.27 117.18 98.27 0 0 58.6 0 175.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "0 175.79 98.27 117.18 196.5 175.79 98.21 234.35 0 175.79"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "98.15 38.4 32.17 77.79 32.17 156.58 98.2 195.94 164.27 156.58 164.27 77.79 98.15 38.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m153.23,136.88l-10.97,6.55v.03l-.03-.02-10.97,6.55v.03l-.03-.02-10.94,6.52v.05l-.05-.02-10.99,6.55v.03l-.03-.02-11,6.56v26.26l11.05-6.58v-.02l11.04-6.58,10.96-6.52,11.02-6.58,10.97-6.53,11-6.56v-26.26l-11.02,6.56Zm-33,32.81l.05-.03v.05l-.05-.02Zm22.01-13.11l.03-.02v.03l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "87.21 176.26 87.19 176.26 76.2 182.82 87.21 189.38 98.21 195.94 98.21 182.82 98.21 169.68 87.21 176.26"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.18,44.95l-10.97-6.55-11,6.58-11,6.56-11.02,6.58-10.97,6.55-.02.02-10.97,6.55-.03.03-11,6.56,11,6.56,11,6.55,10.99-6.55v-.05l.03.02,10.99-6.55v-.02h.02l10.99-6.55v-.02l10.96-6.55.03-.02h.02v-.02l10.97-6.55v-.03l.03.02,10.99-6.55-11.02-6.59Zm-54.99,32.86v-.03l.03.02-.03.02Zm10.99-6.56v-.03l.02.02-.02.02Zm11-6.56l.02-.02v.02h-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.19 84.39 32.19 77.82 32.19 90.95 32.19 104.07 43.19 97.51 54.19 90.95 54.19 90.93 43.19 84.39"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m131.26,110.63h0s-10.99-6.56-10.99-6.56h-.02s-10.96,6.52-10.96,6.52v.06l-.05-.03-11.01,6.56-11,6.57h0s-11,6.57-11,6.57l-11,6.57-.03.02-10.97,6.55h0s-11,6.57-11,6.57l-11,6.57,22,13.12h.02s10.95-6.53,10.95-6.53v-.06l.05.03,10.99-6.57h0s0,0,0,0l11-6.57h0s0,0,0,0l11-6.57h0l11-6.56h0l.04-.03,10.96-6.53.04-.02,10.97-6.54h0s11-6.56,11-6.56l-11-6.56Zm-66.08,39.4v-.04l.03.02-.03.02Zm44.1-26.25l-.05-.03.05-.03v.05Zm10.99-6.57l-.03-.02.03-.02v.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m164.32,90.97l-.03-.02.03-.02v-13.09s-.03-.01-.03-.01l-11.01,6.56-11.01,6.56v26.25h0l11-6.56h.01s10.99-6.56,10.99-6.56l.04-.03v-13.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "142.27 90.95 142.27 117.2 131.27 110.64 120.26 104.08 120.26 77.83 131.27 84.39 131.27 84.39 131.27 84.39 142.27 90.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m164.27,77.82h0s-10.99-6.56-10.99-6.56h0s0,0,0,0l-10.99-6.56-.04.03-10.96,6.54h0s-11,6.57-11,6.57l11,6.56h0s0,0,0,0l10.94,6.52h0s.06.04.06.04l10.99-6.55h.02s0-.01,0-.01l10.98-6.54h.02s-.02-.02-.02-.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m76.27,143.46l-.03-.02.03-.02v-13.09s-.03-.01-.03-.01l-11.01,6.56-11.01,6.56v26.25h0l11-6.56h.01s10.99-6.56,10.99-6.56l.04-.03v-13.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "54.22 143.43 54.22 169.69 43.22 163.13 32.21 156.57 32.21 130.32 43.22 136.87 43.22 136.88 43.22 136.88 54.22 143.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m76.22,130.31h0s-10.99-6.56-10.99-6.56h0s0,0,0,0l-10.99-6.56-.04.03-10.96,6.54h0s-11,6.57-11,6.57l11,6.56h0s0,0,0,0l10.94,6.52h0s.06.04.06.04l10.99-6.55h.02s0-.01,0-.01l10.98-6.54h.02s-.02-.02-.02-.02Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalLogo);
export default __webpack_public_path__ + "static/media/ArrivalLogo.1e407d96c665bbd64df2dee5499cab38.svg";
export { ForwardRef as ReactComponent };